import * as React from "react";
const SvgFiBrandsAfterEffects = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 25 24"
    {...props}
  >
    <g fill="#151A2D" clipPath="url(#fi-brands-after-effects_svg__a)">
      <path d="m8.08 8.144 1.343 4.17h-2.65z" />
      <path d="M20.573.3H4.427C1.982.3 0 2.203 0 4.55v14.9c0 2.347 1.982 4.25 4.427 4.25h16.146c2.445 0 4.427-1.903 4.427-4.25V4.55C25 2.203 23.018.3 20.573.3m-7.326 16.5h-2.18a.155.155 0 0 1-.168-.113l-.856-2.387H6.169l-.789 2.355a.196.196 0 0 1-.2.145H3.217q-.169 0-.118-.177l3.354-9.235c.034-.097.068-.191.101-.314q.066-.324.067-.653a.1.1 0 0 1 .087-.113h2.696q.117 0 .134.08l3.807 10.25q.05.162-.1.162m8.175-3.986a13 13 0 0 1-.042.419.15.15 0 0 1-.15.129q-.1 0-.345.024a8 8 0 0 1-.604.032c-.24.006-.494-.034-.762-.034h-3.304a2.2 2.2 0 0 0 .318.887c.188.269.452.478.763.604.42.175.875.26 1.333.25a6.4 6.4 0 0 0 1.082-.113q.48-.063.93-.232.085-.064.085.08v1.53a.23.23 0 0 1-.025.12.2.2 0 0 1-.075.073 4.4 4.4 0 0 1-1.04.297q-.73.132-1.476.12c-1.253 0-2.48-.348-3.304-1.303-.648-.753-.94-1.793-.94-2.77 0-1.058.333-2.13 1.04-2.953.767-.891 1.822-1.263 3.002-1.263 1.014 0 2.064.327 2.717 1.103.549.65.822 1.528.822 2.359q0 .35-.025.64m-3.597-2.367a1.47 1.47 0 0 0-1.383.756 2.2 2.2 0 0 0-.226.713h2.197q.402 0 .595-.008a.6.6 0 0 0 .243-.077v-.097a1.2 1.2 0 0 0-.067-.37c-.186-.564-.742-.94-1.359-.917" />
    </g>
    <defs>
      <clipPath id="fi-brands-after-effects_svg__a">
        <path fill="#fff" d="M0 0h25v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsAfterEffects;
